import { GlobalState } from '@core/models/types/store.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectGlobal = createFeatureSelector<GlobalState>('global');

export const selectIsLoading = createSelector(
  selectGlobal,
  (state) => state.isLoading
);

export const selectRedirectUrlLoginSuccess = createSelector(
  selectGlobal,
  (state) => (state.redirectUrlLoginSuccess)
);
